import React, { Component } from 'react';

import ProfileForm from './components/ProfileForm/ProfileForm';
import './ProfilePage.scss';

export default class ProfilePage extends Component {
	render() {
		return (
			<div className="ProfilePage">
	            <h2>Profile</h2>
				<ProfileForm/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProfilePage/ProfilePage.js